import * as React from "react";

export default function ProfessionFilter({ icon, label, selected, onClick, className }) {
  return (
    <button 
      onClick={onClick}
      className={`flex flex-col justify-between items-center px-0.5 md:px-1.5 py-1.5 ${selected ? 'bg-green-100 text-shi-deep-purple' : 'bg-white text-black'} rounded-xl border ${!selected ? 'border-zinc-100' : 'border-shi-green'} h-[60px] w-[70px] md:h-[100px] md:w-[100px] ${className}`}
      aria-pressed={selected}
    >
      {icon}
      <div className="md:mt-2 mt-[1px] text-[10px] md:text-[14px]">{label}</div>
    </button>
  );
}